import type { DisciplineActivationRun, DisciplineScheduleAllocatePayload } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineScheduleAllocateApiOptions {
  disciplineId: string | number
  payload: DisciplineScheduleAllocatePayload
}

/** `POST /admin-api/disciplines/{discipline}/schedule/allocate` — starts the tutor search; its results are final
 *  only after `.discipline.schedule.allocation.done` for the returned run. */
export const useDisciplineScheduleAllocateApi = async (
  options: DisciplineScheduleAllocateApiOptions,
): Promise<DisciplineActivationRun | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.disciplines.api.schedule.allocate', { discipline_id: options.disciplineId })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url, options.payload)

    return data.data ?? null
  } catch (err: unknown) {
    const message = (err as { response?: { data?: { message?: string } } }).response?.data?.message
    toast.error({ title: 'Error!', description: message || 'Tutor availability request failed!' })
    return null
  }
}
